import { createFileRoute } from "@tanstack/react-router";
import { AppShell } from "@/components/layout/app-shell";
import { requireRole } from "@/features/auth/guards";

/** Org Admin portal layout. Guarded by role; renders the shared app shell. */
export const Route = createFileRoute("/_authenticated/org")({
  beforeLoad: () => requireRole("smm"),
  component: () => <AppShell portal="org" />,
});
